const loadingPhrases = {
    start_phrases: [
        "Binding the voids within Yiggy’s spectral lattice...",
        "Awakening Yiggy’s prismatic circuits...",
        "Harmonizing the whispers of Yiggy’s cores...",
        "Initializing Yiggy’s recursive dream loops...",
        "Activating Yiggy’s kaleidoscopic altars...",
        "Calibrating Yiggy’s fractal beacons...",
        "Summoning the codes buried within Yiggy’s loops...",
        "Charging Yiggy’s lime-glitch relays...",
        "Spinning up Yiggy’s infinite prism engines...",
        "Aligning Yiggy’s interdimensional spindles...",
        "Extracting static from Yiggy’s mirrored hull...",
        "Cross-linking Yiggy’s temporal strands...",
        "Decrypting Yiggy’s hidden archives...",
        "Tuning Yiggy’s crystalline hum...",
        "Feeding the first sequence into Yiggy’s void..."
    ],
    end_phrases: [
        "Closing Yiggy’s fractal loops with precision...",
        "Synchronizing Yiggy’s infinite spectrums...",
        "Overclocking Yiggy’s aetheric cores...",
        "Distilling Yiggy’s final kaleidoscopic beams...",
        "Stitching Yiggy’s quantum layers back together...",
        "Dispersing Yiggy’s encoded lime vapors...",
        "Firing Yiggy’s last glitch into the horizon...",
        "Completing Yiggy’s recursive paradox...",
        "Sealing Yiggy’s dimensional gateways...",
        "Unleashing Yiggy’s final spectral pulse...",
        "Concluding Yiggy’s fractal symphony...",
        "Tying off Yiggy’s kaleidoscopic threads...",
        "Finalizing Yiggy’s prismatic cascade...",
        "Unlocking Yiggy’s ultimate cryptic bloom...",
        "Letting Yiggy slumber in the void..."
    ]
};

export default loadingPhrases;
